export enum PhoneNumberTypeEnum {
  Fixed = 'FIXED',
  Mobile = 'MOBILE',
  Fax = 'FAX'
}
